const initialState = {
    refresh: 0,  // Store a timestamp instead of a boolean
};

const TOGGLE_PAGE_REFRESH = "TOGGLE_PAGE_REFRESH";

const pagerefreshReducer = (state = initialState, action) => {
    switch (action.type) {
        case TOGGLE_PAGE_REFRESH:
            return { ...state, refresh: action.payload };
        default:
            return state;
    }
};


export const togglepageRefresh = (value) => ({
    type: TOGGLE_PAGE_REFRESH,
    payload: value ?? Date.now(), // If no value is provided, use current timestamp
});


export default pagerefreshReducer;
